import React from 'react';

import { hasModule, iaRa, mString } from 'lib/helpers/utility';

import { getInvoiceItemDiscountCents } from 'components/practice/NewAppointment/components/Sections/Pricing/components/ProceduresProduct/components/SelectedItems/helpers';

import DetailsCell from '../cells/DetailsCell';

export const DEFAULT_COL_DEFS = {
  cellClass: 'no-border break-word-cell',
  enableRowGroup: true,
  resizable: true,
  filter: false,
  suppressMenu: true,
  suppressMovable: true,
  flex: 1,
  minWidth: 80,
  autoHeight: true,
  editable: false,
  wrapText: true
};

export const GRID_OPTIONS = {
  domLayout: 'autoHeight',
  animateRows: true,
  rowGroupPanelShow: 'always'
};

export const INVOICE_COLUMN_DEFS = (isMobile, practiceModules) =>
  [
    {
      headerName: 'Service description',
      field: 'details',
      minWidth: 240,
      cellClass: 'min-w-[240px]',
      cellRenderer: (params) => <DetailsCell {...params} key="details" />
    },
    ...(!isMobile
      ? [
          {
            headerName: 'CPT® code',
            field: 'procedure_code'
          },
          {
            headerName: 'Dx code',
            field: 'icd_10_codes',
            cellClass: 'max-w-[120px]',
            valueFormatter: ({ value }) => iaRa(value).join(', ')
          }
        ]
      : []),
    {
      headerName: 'Prov. charge',
      field: 'charge',
      valueFormatter: ({ value }) => mString(value ?? 0),
      aggFunc: 'sum'
    },
    hasModule(practiceModules, 'billing.claims') && {
      headerName: 'Allowed amt.',
      field: 'allowed_amount',
      valueFormatter: ({ value }) => mString(value ?? 0),
      aggFunc: 'sum'
    },
    hasModule(practiceModules, 'billing.claims') && {
      headerName: 'Ins. pays',
      field: 'ins_payment',
      valueFormatter: ({ value }) => mString(value ?? 0),
      aggFunc: 'sum'
    },
    hasModule(practiceModules, 'billing.claims') && {
      headerName: 'Ins. adj.',
      field: 'ins_adjustment',
      cellRenderer: ({ data }) => {
        return mString((data?.ins_adjustment ?? 0) - (data?.other_adj ?? 0));
      },
      valueFormatter: ({ data }) => mString((data?.ins_adjustment ?? 0) - (data?.other_adj ?? 0)),
      aggFunc: 'sum'
    },
    hasModule(practiceModules, 'billing.claims') && {
      headerName: 'Ins. bal.',
      field: 'ins_balance',
      valueFormatter: ({ value }) => mString(value ?? 0),
      aggFunc: 'sum'
    },
    {
      headerName: 'Discount',
      field: 'discount',
      valueFormatter: ({ value, data }) =>
        mString(data ? getInvoiceItemDiscountCents(data) : (value?.amount_cents ?? 0)),
      aggFunc: 'sum'
    },
    {
      headerName: 'State tax',
      field: 'state_tax',
      valueFormatter: ({ value }) => mString(value ?? 0),
      aggFunc: 'sum'
    },
    {
      headerName: 'Local tax',
      field: 'local_tax',
      valueFormatter: ({ value }) => mString(value ?? 0),
      aggFunc: 'sum'
    },
    {
      headerName: 'Patient resp.',
      field: 'ptBalance',
      valueFormatter: ({ value }) => mString(value ?? 0),
      aggFunc: 'sum'
    }
  ].filter(Boolean);
